/**
  * this create sub nav effect
  * used in photo page and tour archive page
**/
import $ from 'jquery';

export const initDropdownNav = () => {
	let outsideClickActive= false;

	
	$('.dowpdownNavSet').click(function(){
		
		//event.stopPropagation(); //cannot use this because of conflict caused with mobile menu
		//$(this).toggle(".active");
		if($(this).find(".subMenu").hasClass('open')){
			$(this).find(".subMenu").removeClass('open')
			$(".dowpdownNavSet").removeClass("active");
		}else{
			$(".dowpdownNavSet").removeClass("active");
			$(this).addClass("active");
			const outsideClickListener = () => {
				if(outsideClickActive){
			    	$(".dowpdownNavSet .subMenu").removeClass('open');
						$(".dowpdownNavSet").removeClass("active");
			    	outsideClickActive= false;
			    	document.removeEventListener('click', outsideClickListener);
				}
			};
			
			if(outsideClickActive){
				document.removeEventListener('click', outsideClickListener);
				outsideClickActive= false;
			}
			
			//$('.dowpdownNavSet').removeClass('active');
			$(".dowpdownNavSet .subMenu").removeClass('open');
			$(this).find(".subMenu").addClass('open');
			
			
			//block of code to close sub menu if clicked outside the menu
			if(!outsideClickActive){
				document.addEventListener('click', outsideClickListener);
				setTimeout(function(){ 
					outsideClickActive= true;; 
				}, 500);
				
				
			}
			
		}

	});

}
